

<c-row class="py-4">
  <c-col xs>
    <div class="reports-header mb-4">
      <div>
        <h2 class="reports-title mb-1">Reports</h2>
        <p class="text-muted mb-0">View attrition updates and monthly retention data</p>
      </div>
    </div>

    <div class="reports-tabs mb-0">
      <button
        class="reports-tab-btn"
        [class.active]="activeTab === 'attrition'"
        (click)="setTab('attrition')">
        <span class="tab-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>
          </svg>
        </span>
        Attrition Updates
      </button>
      <button
        class="reports-tab-btn"
        [class.active]="activeTab === 'retention'"
        (click)="setTab('retention')">
        <span class="tab-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M0 0h1v15h15v1H0V0zm14.828 2.172a.5.5 0 0 0-.707 0L8 8.293 5.854 6.146a.5.5 0 0 0-.707 0l-5 5a.5.5 0 0 0 .707.708L5.5 7.207l2.146 2.147a.5.5 0 0 0 .707 0l6.475-6.475a.5.5 0 0 0 0-.707z"/>
          </svg>
        </span>
        Retention Data
      </button>
    </div>

    <div class="reports-tab-content">
      <div *ngIf="activeTab === 'attrition'">
        <app-attrition-updates></app-attrition-updates>
      </div>
      <div *ngIf="activeTab === 'retention'">
        <app-retention-data></app-retention-data>
      </div>
    </div>
  </c-col>
</c-row>
